import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=944719fc&scoped=true&"
import script from "./AppDetail.vue?vue&type=script&lang=js&"
export * from "./AppDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=944719fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944719fc",
  null
  
)

export default component.exports